<section class="header-section">
    <span class="image">
        <img class="logo-horizontal-secundario" width="120px" src="assets/img/logo-horizontal-secundario.svg" alt="logo"> 
    </span>
</section>  

<section class="onboarding-steps">
    <router-outlet></router-outlet>
</section>

<section class="iconos-footer" style="flex-direction: row; gap: 10px;">
    <div *ngIf="mostrarPCI()" class="btn-float-certidied">
        <img width="100px" height="67px" src="assets/img/pci-logo.webp" alt="certified" class="img-fluid">
    </div>
    
    <div class="btn-float"  (click)="sendMessage()">
        <div style="justify-content: center;
            align-items: center; display: flex; font-size: 12px;">
            <div>
                <i style="color: #2CD46B; font-size: 40px;" class='icon-float bx bxl-whatsapp'></i>
            </div>
        </div>
    </div>
    
</section>



<section class="footer-section">
    <span style="display: flex;
        justify-content: center;
        align-items: center;">
        <i style="font-size: 26px;" class='bx bxs-lock-open-alt'></i>  
        <span class="font-title-bold">&nbsp;Sitio protegido por SSL / TLS</span>
    </span>
</section>